/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from 'antd';
import React, { useCallback } from 'react';
import Text from './components/text';
import CustomSelect from './components/select';
import CustomAjaxSelect from './components/ajaxSelect';
import { getShowIfValues, keysWithNoShowIf } from '../helper';

export default function Footer({
  inputs = {},
  firstItem = '',
  data = {},
  setData = () => { },
  requiredFields = [],
  setRequiredFields = () => { },
  t = (s) => s,
  areYouSureState = false,
  renderLabels = false,
}) {
  const updateData = useCallback((k, value, test) => {
    setData((prev) => {
      const prevItems = { ...prev };
      prevItems[k] = value;
      return prevItems;
    });
  }, [setData]);

  const checkRequiredFields = useCallback((showIf, key) => {
    if (showIf) {
      if (!requiredFields.includes(key)) {
        setRequiredFields((prev) => [...prev, key]);
      }
    } else {
      if (data[key]) {
        updateData(key, undefined);
      }
      if (requiredFields.includes(key)) {
        setRequiredFields((prev) => [...prev.filter((p) => p !== key)]);
      }
    }
  }, [requiredFields, setRequiredFields, data]);

  const renderInputs = useCallback(() => Object.entries(inputs).map(([k, v]) => {
    if (v) {
      let showIf = true;

      if (v.showIf) {
        if (!keysWithNoShowIf.includes(k)) {
          showIf = getShowIfValues(v.showIf, data);
        }
      }

      checkRequiredFields(showIf, k);

      const getValue = () => {
        switch (v.inputType) {
          case 'select':
            return (
              <CustomSelect
                v={v}
                k={k}
                key={k}
                updateData={updateData}
                data={data}
                showIf={showIf}
                areYouSureState={areYouSureState}
                placeholder={inputs[k].placeholder}
              />
            );
          case 'text':
            return (
              <Text
                updateData={updateData}
                k={k}
                key={k}
                v={v}
                data={data}
                firstItem={firstItem}
                showIf={showIf}
                areYouSureState={areYouSureState}
                placeholder={inputs[k].placeholder}
              />
            );
          case 'ajaxSelect':
            return (
              <CustomAjaxSelect
                k={k}
                v={v}
                key={k}
                updateData={updateData}
                showIf={showIf}
                data={data}
                areYouSureState={areYouSureState}
                placeholder={inputs[k].placeholder}
              />
            );
          case 'multiselect':
            if (v.group === 'location') {
              return (
                <Text
                  updateData={updateData}
                  k={k}
                  key={k}
                  v={v}
                  data={data}
                  firstItem={firstItem}
                  areYouSureState={areYouSureState}
                  placeholder={inputs[k].placeholder}
                />
              );
            }
            return <div className="item" key={k} />
          default:
            return <div className="item" key={k} />;
        }
      };

      const value = getValue();

      return (
        <div className='item' key={k}>
          {renderLabels ? (
            <Form.Item label={inputs[k].columnConfig?.title} required />
          ) : null}
          {value}
        </div>
      )
    }
    return <div className="item" key={k} />;
  }), [getShowIfValues, data, inputs, requiredFields, areYouSureState]);

  return (
    <>
      <h5 className="final-output">{t('Final Output')}</h5>
      <div className="row footer-row no-borders">
        {renderInputs()}
      </div>
    </>
  );
}
